// tslint:disable
export var DocumentGroupStatus;
(function (DocumentGroupStatus) {
    // UNKN
    DocumentGroupStatus[DocumentGroupStatus["UNKN"] = 0] = "UNKN";
    // LOAD
    DocumentGroupStatus[DocumentGroupStatus["LOAD"] = 1] = "LOAD";
    // PEND
    DocumentGroupStatus[DocumentGroupStatus["PEND"] = 2] = "PEND";
    // MISSINFO
    DocumentGroupStatus[DocumentGroupStatus["MISSINFO"] = 3] = "MISSINFO";
    // PRCSED
    DocumentGroupStatus[DocumentGroupStatus["PRCSED"] = 4] = "PRCSED";
    // UNASGN
    DocumentGroupStatus[DocumentGroupStatus["UNASGN"] = 5] = "UNASGN";
    // NOTRD
    DocumentGroupStatus[DocumentGroupStatus["NOTRD"] = 6] = "NOTRD";
    // SKIP
    DocumentGroupStatus[DocumentGroupStatus["SKIP"] = 7] = "SKIP";
    // EXP
    DocumentGroupStatus[DocumentGroupStatus["EXP"] = 8] = "EXP";
})(DocumentGroupStatus || (DocumentGroupStatus = {}));
//# sourceMappingURL=DocumentGroupStatus.js.map